import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  CreateTraceKeyRequest,
  TraceKeysApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useMutationAddTraceKey = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: CreateTraceKeyRequest) => {
      return await baseClient
        .getApi(TraceKeysApi)
        .addTraceKey({
          createTraceKeyRequest: params,
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      // 成功時にtraceKeysクエリを無効化して再取得する
      queryClient.invalidateQueries({ queryKey: queryKeys.lists() })
    },
  })
}
